import Skeleton from '@material-ui/lab/Skeleton'
import { createStyles, withStyles } from '@material-ui/styles'
import { memo } from 'react'

const RoundedSkeleton = withStyles(() =>
  createStyles({
    root: {
      borderRadius: 12
    }
  })
)(Skeleton)

const ProgressIndicatorSkeleton = () => (
  <RoundedSkeleton variant="rect" height={18} />
)

export default memo(ProgressIndicatorSkeleton)
